import React, { useEffect } from "react";
import { triggerPageViewAnalyticsEvent } from "repoV2/features/Common/Analytics/Analytics.utils";
import useAnalyticsConfig from "repoV2/features/Common/Analytics/hooks/useAnalyticsConfig";
import { useIsMounted } from "repoV2/utils/common/render/mount";
import { isBrowser } from "repoV2/utils/common/render/window";
import GTMScript from "../../../features/Common/Analytics/modules/GoogleTagManager/modules/GTMScript/GTMScript";

export const PageBase = ({
    children,
    hostName,
}: {
    children: React.ReactNode;
    hostName: string;
}) => {
    const isMounted = useIsMounted();
    const { config } = useAnalyticsConfig({ hostName });

    useEffect(() => {
        if (isMounted && isBrowser())
            triggerPageViewAnalyticsEvent({ hostName });
    }, [isMounted]);

    return (
        <>
            {children}
            <GTMScript accessToken={config?.custom_ga_token} />
        </>
    );
};
